import React from 'react';

import PropTypes from 'prop-types';
import { Checkbox, Select, Input, Table } from 'semantic-ui-react';

import clsx from 'clsx';

import ColorPicker from 'components/modules/colors/components/ColorPaletteSelection/components/ColorPicker/ColorPicker';
import { getColorString } from 'components/modules/colors/components/ColorPaletteSelection/components/ColorPicker/ColorPicker.utils';
import { shouldHideColorPicker } from 'components/modules/colors/services/colors';
import PaddingInput from 'components/modules/fields/components/PaddingInput';
import { shouldShowSizeInput } from 'components/modules/fields/services/size';

import {
  formatCssRuleName,
  getEnumOptions,
  isColorRule,
  isEnumRule,
  isRawRule,
  isSizeRule,
} from './StyleConfigurationTableRow.utils';

import './StyleConfigurationTableRow.scss';

const propTypes = {
  rule: PropTypes.string.isRequired,
  value: PropTypes.string,
  enabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  labelMap: PropTypes.shape({}),
};

const defaultProps = {
  value: null,
  enabled: false,
  labelMap: {},
};

export default function StyleConfigurationTableRow({
  rule,
  value,
  enabled,
  onChange: onChangeProp,
  labelMap,
}) {
  function onChange(e, target) {
    const newTarget = { ...target, cssRule: rule };
    onChangeProp({ ...e, target: newTarget }, newTarget);
  }

  const isRaw = isRawRule(rule);
  const isColor = isColorRule(rule);
  const isSize = isSizeRule(rule);
  const isEnum = isEnumRule(rule);

  const className = clsx({ 'style-configuration-table-row': true, [rule]: true });

  return (
    <Table.Row className={className}>
      <Table.Cell>{formatCssRuleName(rule, labelMap)}</Table.Cell>
      <Table.Cell className="input-cell">
        {(isRaw || isSize || isColor) && (
          <Input value={value || ''} name="value" onChange={onChange} disabled={!enabled} />
        )}

        {isColor && !shouldHideColorPicker(getColorString(value)) && (
          <ColorPicker
            withPopUpWrapper
            color={{ hex: value }}
            disabled={!enabled}
            onSelect={(newColor) => {
              onChange({}, { name: 'value', value: getColorString(newColor) });
            }}
          />
        )}
        {isSize && shouldShowSizeInput(value) && (
          <PaddingInput
            name="value"
            padding={+`${value}`.replace('px', '')}
            onChange={(newValue) => {
              onChange({}, { name: 'value', value: `${newValue}px` });
            }}
            disabled={!enabled}
            hideLabel
            maxPaddingAllowed={2000}
          />
        )}
        {isEnum && (
          <Select
            options={getEnumOptions(rule)}
            value={value}
            name="value"
            onChange={onChange}
            disabled={!enabled}
          />
        )}
      </Table.Cell>
      <Table.Cell>
        <Checkbox name="enabled" toggle checked={enabled} onClick={onChange} />
      </Table.Cell>
    </Table.Row>
  );
}

StyleConfigurationTableRow.propTypes = propTypes;
StyleConfigurationTableRow.defaultProps = defaultProps;
